/**
 * Tâche RAG longue (barre + panneau Tasks) : **uniquement si ExhaustiveSearch est activé**
 * (toutes les pages : market, mydeal, legal, oreima).
 *
 * **Search Infravia** = toggle ExhaustiveSearch désactivé → **aucune tâche** (même règle partout).
 * MyGeorges (chat fichier) : jamais de tâche ici.
 */
export function shouldAttachLegalSearchTask(
  page: string,
  selectedMode: string,
  exhaustiveSearchEnabled: boolean
): boolean {
  const p = String(page || "")
    .trim()
    .toLowerCase();
  const allowedPages = new Set(["legal", "oreima", "market", "mydeal"]);
  if (!allowedPages.has(p)) return false;
  const mode = String(selectedMode || "")
    .trim()
    .toUpperCase();
  if (mode === "MYGEORGES") return false;
  if (!exhaustiveSearchEnabled) return false;
  return true;
}
